import React from 'react'

function FixtureDateHandler({date, setDate}) {

    function dateChangeHandler(type) {

        const currentDate = new Date(date);

        let currentYear = currentDate.getFullYear();
        let currentMonth = currentDate.getMonth()+1
        let currentDay = currentDate.getDate();

        // If next || prev && month === 1 || month === 12 --> currentYear = currentYear-1 || currentYear+1


        // Get number of days in month
        function daysInMonth (month, year) {
            return new Date(year, month, 0).getDate();
        }
        let daysPerMonth = daysInMonth(currentMonth, currentYear)


        if (type === "next") {

            if (currentDay === daysPerMonth) {

                if (currentMonth === 12) {
                    currentMonth = 1
                    currentYear = currentYear+1
                } else {
                    currentMonth = currentMonth+1
                }

                
                currentDay = 1;
            } else {
                currentDay = currentDay+1
            }

        } else if (type === "prev") {

            if (currentDay === 1) {
                if (currentMonth === 1) {
                    currentMonth = 12
                    currentYear = currentYear-1
                } else {
                    currentMonth = currentMonth-1
                }
                
                let daysPrevMonth = daysInMonth(currentMonth, currentYear)
                currentDay = daysPrevMonth;
                console.log("if ran prev")
            } else {
                currentDay = currentDay-1
                console.log("Else ran prev")
            }
            console.log(currentDay, currentMonth)

        }

        if (currentMonth < 10) {
            currentMonth = `0${currentMonth}`
        }
        if (currentDay < 10) {
            currentDay = `0${currentDay}`
        }
        const dateToSet = currentYear + '-' + currentMonth + '-' + currentDay
        setDate(dateToSet)
        localStorage.setItem("date_selected", dateToSet)

    }

    return (
        <div className="row py-4">
            <div className="col-2 text-center">
                <div onClick={() => dateChangeHandler("prev")}>
                    <i className="fas fa-chevron-left pt-2"></i>
                </div>
                
            </div>
            <div className="col-8">
                <input 
                    className="form-control" 
                    value={date} 
                    type="date" 
                    onChange={e => setDate(e.target.value)} 
                />
            </div>
            <div className="col-2">
                <div className="text-center" onClick={() => dateChangeHandler("next")}>
                    <i className="fas fa-chevron-right pt-2"></i>
                </div>
            </div>
        </div>
    )

}
export default FixtureDateHandler